import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { _InfoHolderLocked, _InfoHolderDetail, _LockedCta } from './styles'

const InfoHolderLocked = ({
  onRegister, onLogin, requiredEmailVerification,
  openEmailVerifyModal,
  source,
  requireTermsConditionAgreement,
  onTermsConditionClick,
}) => (
  <_InfoHolderLocked>
    <_InfoHolderDetail>
      {
        requireTermsConditionAgreement
          ? (
            <_LockedCta
              data-test-id="infoHolderTermsConditionText"
              onClick={onTermsConditionClick}
            >
              Agree to {source}{source === 'PILLAR9' ? '\u2122' : ''} terms to view
            </_LockedCta>
          )
          : requiredEmailVerification ?
            <Fragment>
              <_LockedCta
                data-test-id="infoHolderVerifyEmail"
                onClick={() => openEmailVerifyModal()}
              >
                Verify your email
              </_LockedCta>
              &nbsp;
              to view
            </Fragment>
            : (
              <Fragment>
                <_LockedCta onClick={onRegister}>
                  Sign up
                </_LockedCta>
                &nbsp;or&nbsp;
                <_LockedCta onClick={onLogin}>
                  Log in
                </_LockedCta>
                &nbsp;
                to view
              </Fragment>
            )
      }
    </_InfoHolderDetail>
  </_InfoHolderLocked>
)


InfoHolderLocked.propTypes = {
  onRegister: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  requiredEmailVerification: PropTypes.bool,
  openEmailVerifyModal: PropTypes.func,
  source: PropTypes.string,
  requireTermsConditionAgreement: PropTypes.bool,
  onTermsConditionClick: PropTypes.func,
}


export default InfoHolderLocked

